import React from 'react';
import { ButtonTertiary, Numberbox, Textarea } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import * as navigate from 'app/area/shared/navigation';
import { SelectSingle } from 'app/area/shared/translated-components';
import { GroupText } from 'app/components/group-text/group-text';
import { CompanyReportFormIds } from '../constants';
import { endpoints } from '../endpoints';
import { textIdDebounceTime } from './constants';
import { EmailSettingsProps } from '../types';
import { emailBodyFieldsRequired, getOnlyExistedValues } from './helpers';

import styles from './email-settings-group.scss';

export const EmailSettingsGroup: React.FC<EmailSettingsProps> = ({
  companyReportItem, options, locale, validation, translation,
  updateItem, resetValidation, loadOptions, updateTextDescription, translationAdminAccess
}) => {

  const onTextSetChange = (value: ComplexValue<number>) => {
    updateItem({ textSet: getOnlyExistedValues(value) });
    resetValidation(CompanyReportFormIds.textDescription);

    const textIdValue = companyReportItem?.textId;
    textIdValue && updateTextDescription(textIdValue, value?.value);

    resetFieldsValidation();
  };

  const onTextIdChange = (value: number) => {
    updateItem({ textId: value });
    resetValidation(CompanyReportFormIds.textDescription);
    resetValidation(CompanyReportFormIds.emailSetting);

    const textSetValue = companyReportItem?.textSet?.value;
    textSetValue && updateTextDescription(value, textSetValue);

    resetFieldsValidation();
  };

  const resetFieldsValidation = () => {
    resetValidation(CompanyReportFormIds.textSet);
    resetValidation(CompanyReportFormIds.textId);
  };

  const onTextSetLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(CompanyReportFormIds.textSet, endpoints.textSetAllOptions, loadOptionsParams);
  };

  const onManageText = () => {
    navigate.toTextItem(companyReportItem?.textId, companyReportItem?.textSet?.value);
  };

  const required = emailBodyFieldsRequired(companyReportItem);

  const readOnly = !companyReportItem?.emailReport;

  return <div className="row">
    <div className="col-md-12" >
      <GroupText>{translation.email_settings_body_title}</GroupText>
      <div className={styles.container}>
        <div className="row mt-3">
          <div className="col-lg-3 col-sm-12">
            <SelectSingle
              componentId={CompanyReportFormIds.textSet}
              className={undefined}
              label={{ text: translation.email_settings_text_set, required }}
              valueItem={companyReportItem?.textSet}
              onChange={onTextSetChange}
              validation={validation?.textSet}
              placeholder={translation?.search}
              options={options?.textSet?.codes as ComplexValue<number>[] || []}
              fetching={options?.textSet?.fetching}
              loadOptions={undefined}
              onLoadOptions={onTextSetLoadOptions}
              readOnly={readOnly} />
          </div>
          <div className="col-lg-3 col-sm-12">
            <Numberbox
              componentId={CompanyReportFormIds.textId}
              label={translation ? { text: translation.email_settings_text_id, required } : undefined}
              value={companyReportItem?.textId}
              onChange={onTextIdChange}
              useThousand=" "
              maxValue={999999999}
              locale={locale}
              validation={validation?.textId}
              textInvalidRangeError={translation.must_be_within_range}
              readOnly={readOnly}
              wait={textIdDebounceTime} />
          </div>
          <div className="col-lg-4 col-sm-12">
            <Textarea
              componentId={CompanyReportFormIds.textDescription}
              readOnly={true}
              value={companyReportItem?.textDescription}
              label={{ text: translation.email_text_description, required }}
              validation={validation?.textDescription?.messages.length ? validation?.textDescription : validation.emailSetting} />
          </div>
          {translationAdminAccess &&
            <div className={`col-lg-2 col-sm-12 ${styles.buttonWrapper}`}>
              <ButtonTertiary
                disabled={!companyReportItem?.textDescription}
                onClick={onManageText}>
                {translation.email_manage_text}
              </ButtonTertiary>
            </div>}
        </div>
      </div>
    </div>
  </div>;
};
